import React from 'react';
const IconActionInsert = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M2 6H14V8H2V6ZM2 10H14V12H2V10ZM18 10H16V14H12V16H16V20H18V16H22V14H18V10ZM10 16H2V14H10V16Z" fill="#666666"/>
</svg>
);
};
export default IconActionInsert;